import {classNames, Keys, observer, React} from '@api'
import {Button, Icon, InputGroup, Spinner} from '@blueprintjs/core'
import {Tooltip2} from '@api'
import {CircularProgress, Tooltip} from '@material-ui/core'
import {FilterGroup, FilterStore, useFilterStore} from '@modules'
import {BoardSectionFilterDropdown} from './'
import * as css from './SearchFilter.css'

import {action, computed, observable, when} from 'mobx'

export class SearchFilterStore {
  constructor(public filter: FilterStore) {
    when(() => filter.library != null || filter.parsedUrl, () => {
      this.search = filter.state.search
    })
    filter.searchFilterStore = this
  }

  // @autorun(() => {
  //
  // })

  @observable search

  @computed get isSearching() {
    return this.search != this.filter.state.search
  }

  @computed get loading() {
    const {filter, isSearching} = this
    return filter.hasPendingChanges || filter.loading
  }

  @action onKeyDown = (e: React.KeyboardEvent) => {
    if (e.keyCode == Keys.ESCAPE) {
      this.search = ''
    }
  }

  @action onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.search = e.currentTarget.value
    //this.filter.state.search = e.currentTarget.value
  }
}

export const SearchFilterGroup = observer<{className?: string, children?: React.ReactNode, noSectionDropdown?: boolean}, any>(function SearchFilterGroup({className, children, noSectionDropdown}, ref) {
  const filter = useFilterStore(),
    {strings, searchFilterStore: {search, loading, onKeyDown, onChange}} = filter

  return (
    <FilterGroup className={classNames(className, css.root)}
                 ref={ref}
                 group='search'
                 >
      <div className={css.toolbar}>
        <InputGroup
          placeholder={strings.searchFilters(null)}
          className={classNames(css.searchInput)}
          fill
          value={search ?? ''}
          onKeyDown={onKeyDown}
          onChange={onChange}
          leftIcon='search'
          rightElement={
            loading
            ? <Tooltip2 placement='right' content={'Search Now'}>
              <Button className={classNames(css.loader, 'animate__animated animate__fadeIn')}
                      onClick={filter.commitPendingToggles}>
                {/*<CircularProgress size={20} color='secondary' />*/}
                <Spinner size={18} />
              </Button>
            </Tooltip2>
            : <Icon icon='blank'/>
          }
        />

        {!noSectionDropdown && <BoardSectionFilterDropdown className={css.sectionDropdown}/>}
        {children}
      </div>
    </FilterGroup>)
}, {forwardRef: true})



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/filters/components/internal/SearchFilter.tsx